import { AutogenModelEmailContact, AutogenRowEmailContact } from "./autogen/AutogenModelEmailContact";

export class ModelEmailContact extends AutogenModelEmailContact<RowEmailContact> {
	constructor() {
		super(RowEmailContact);
	}
}

export class RowEmailContact extends AutogenRowEmailContact {
}